import {
  measuredUsingConfigFor,
  mergeConfig,
  wrapAsDerivedFromMeasurementsConfig as wrap,
} from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from 'Components/Worksheets/QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) => {
  return mergeConfig(
    {
      [`${prefix}.Equipment.Balance`]: { defaultReadability: 0.1, defaultUom: 'g' },
      [`${prefix}.Sieves.WetMassRetainedPercent`]: { uom: 'g', format: { nearest: 1 } },
    },
    getMeasuredUsingConfig(prefix),
    getLabelConfig(prefix)
  );
};

const getMeasuredUsingConfig = (prefix: string) => {
  const balance = measuredUsingConfigFor(`${prefix}.Equipment.Balance`);
  return {
    [`${prefix}.Sieves.TareMass`]: balance,
    [`${prefix}.Sieves.TarePlusWetMassRetained`]: balance,
    [`${prefix}.Sieves.WetMassRetained`]: wrap([
      `${prefix}.Sieves.TareMass`,
      `${prefix}.Sieves.TarePlusWetMassRetained`,
    ]),
  };
};

export { getConfig };

export default {
  [qestIds.oversizeDetermination.BS_1377_2_Clause_9_2]: getConfig,
};
